import { render, staticRenderFns } from "./autoCC.vue?vue&type=template&id=4ca5e2a8&scoped=true"
import script from "./autoCC.vue?vue&type=script&lang=js"
export * from "./autoCC.vue?vue&type=script&lang=js"
import style0 from "./autoCC.vue?vue&type=style&index=0&id=4ca5e2a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca5e2a8",
  null
  
)

export default component.exports